import { render, staticRenderFns } from "./GraphQlFileUpload.vue?vue&type=template&id=67bd489d&scoped=true&"
import script from "./GraphQlFileUpload.vue?vue&type=script&lang=ts&"
export * from "./GraphQlFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./GraphQlFileUpload.vue?vue&type=style&index=0&id=67bd489d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd489d",
  null
  
)

export default component.exports